module.exports = __webpack_public_path__ + "img/215.0dd3a4da.jpg";